import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { EXECUTE_SURGE_COMPAIGN, EXECUTE_SURGE_COMPAIGN_SUCCESS, EXECUTE_SURGE_COMPAIGN_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

// Runs an active campaign immediately, outside its normal cron schedule.
function* executeSurgeCompaign({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-campaigns/${payload?.campaignId}/trigger-now`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message || `Campaign triggered successfully.`);
      yield put({
        type: EXECUTE_SURGE_COMPAIGN_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || `Failed to trigger campaign.`;
      cogoToast.error(message);
      yield put({
        type: EXECUTE_SURGE_COMPAIGN_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error(`Failed to trigger campaign.`);
    yield put({ type: EXECUTE_SURGE_COMPAIGN_ERROR, payload: error });
  }
}

export function* watchexecuteSurgeCompaign() {
  yield takeEvery(EXECUTE_SURGE_COMPAIGN, executeSurgeCompaign);
}

function* executeSurgeCompaignSaga() {
  yield all([fork(watchexecuteSurgeCompaign)]);
}

export default executeSurgeCompaignSaga;
